import React from "react";
import { doc, deleteDoc } from "firebase/firestore";
import { fireDB } from "../config";
import {
  Card,
  Box,
  Typography,
  IconButton,
  CardMedia,
  CardActions,
  CardContent,
} from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
const ProductList = ({ ...props }) => {
  let navigate = useNavigate();

  const handleDetail = (propId) => {
    navigate(`/dashboard/addproduct/${propId}`);
  };
  const handleDelete = async (docId) => {
    const delRef = doc(fireDB, "products", docId);

    await deleteDoc(delRef);
  };

  return (
    <Card
      sx={{
        borderRadius: 5,
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CardMedia
        component="img"
        alt="green iguana"
        height="190"
        image={props.image}
        sx={{
          borderTopLeftRadius: 5,
          borderTopRightRadius: 5,
        }}
      />
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography
          gutterBottom
          variant="h5"
          component="a"
          onClick={() => navigate(`/dashboard/product/${props.id}`)}
          sx={{ cursor: "pointer" }}
        >
          {props.name}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          ${props.price}
        </Typography>
      </CardContent>
      <Box sx={{ mt: "auto" }} />{" "}
      {/* Added to push the CardActions to the bottom */}
      <CardActions sx={{ display: "flex", justifyContent: "space-between" }}>
        <IconButton size="small" onClick={() => handleDetail(props.id)}>
          <Edit />
        </IconButton>
        <IconButton size="small" onClick={() => handleDelete(props.id)}>
          <Delete />
        </IconButton>
      </CardActions>
    </Card>
  );
};

export default ProductList;
